import SharedFlight from './SharedFlight';
export default SharedFlight;
